import { render, staticRenderFns } from "./cookie-disclaimer.vue?vue&type=template&id=4971dcac&"
import script from "./cookie-disclaimer.vue?vue&type=script&lang=js&"
export * from "./cookie-disclaimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports